import { useMutation } from '@tanstack/react-query'
import { signIn, signOut } from 'aws-amplify/auth'

import { sendEvent } from 'src/shared/api/events/send-event'

export const useConsumerSignInStart = () => {
  return useMutation({
    mutationFn: async (email: string) => {
      // Clear any existing auth sessions to prevent "already signed in" errors
      try {
        await signOut({ global: true })
      } catch (signOutError) {
        // Ignore errors during sign out as the user might not be signed in
        console.warn('Sign-out step:', signOutError instanceof Error ? signOutError.message : 'Unknown error')
      }

      // Initiate sign-in with email to trigger an email OTP
      const result = await signIn({
        username: email,
        options: {
          // Use USER_AUTH flow with EMAIL_OTP as the preferred challenge
          authFlowType: 'USER_AUTH',
          preferredChallenge: 'EMAIL_OTP',
        },
      })

      sendEvent({
        eventType: 'auth_consumer_signin_otp_sent',
        info: { email },
      })

      return result
    },
    onError: (error: unknown) => {
      const errorName = error instanceof Error ? error.name : 'unknown'
      const errorMessage = error instanceof Error ? error.message : 'Unknown error'
      console.error('Sign-in start error:', errorName, errorMessage)

      sendEvent({
        eventType: 'auth_consumer_signin_start_error',
        info: { error: errorName, message: errorMessage },
      })
    },
  })
}
